import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="service-list"
export default class extends Controller {
  static targets = ["list", "button"]
  toggle() {
    this.listTarget.classList.toggle("show")
    this.buttonTargets.forEach((button) => {
      button.classList.toggle("d-none")
    })
  }
}
